import { createEvoClient, messagingFormCreateMessage } from "@jti/evo-client";
import type { OmpRequest } from "@jti/rest-api-types";

import { getUser } from "../../../utils";
import type { RestResponseType } from "../../Rest";
import type { OmpApiContract } from "../OmpApi.types";

export class OmpApiEvo implements OmpApiContract {
  private readonly client;
  constructor(ompServiceUrl: string, tenantToken: string, recaptchaId: string) {
    const user = getUser();
    this.client = createEvoClient({
      baseUrl: ompServiceUrl,
      tenantToken,
      recaptchaId,
      ciamToken: user.ciam_token,
      throwOnError: true,
    });
  }
  async sendMessage(data: OmpRequest, type = "CONTACT"): Promise<RestResponseType> {
    const { collection_point_token, consent_purposes, channel, user, ...rest } = data;

    const { response } = await messagingFormCreateMessage({
      client: this.client,
      body: {
        user,
        type,
        channel,
        payload: rest,
        collection_point_token,
        // @ts-expect-error todo evo schema expects string with comma separated purposes, but if we send string in payload, then evo returns message "The consent purposes must be an array."
        consent_purposes,
        ...(data?.email && { data_subject: data.email }),
      },
    });

    return Promise.resolve({
      statusCode: response.status,
    });
  }
}
